import React, { useEffect, useState, useContext, useRef } from "react";
import debounce from "lodash/debounce";

import { EligibilityContext } from "../../contexts/EligibilityContext";
import SearchResults from "./SearchResults";
import Icon from "../Icon";

const apiUrl = "/wp-json/salesforce/v1/funds";

const Search = (props) => {
  const context = useContext(EligibilityContext);
  const queryEl = useRef(null);
  const diseaseFundRef = useRef();

  const [query, setQuery] = useState("");
  const [error, setError] = useState("");

  const handleSearch = debounce((value) => {
    setQuery("");
    context.actions.setDiseaseFund(null);
    context.actions.setErrorEncountered(false);
    setQuery(value);
  }, 300);

  const reset = () => {
    context.actions.setDiseaseFund(null);
    context.actions.setErrorEncountered(false);
    setQuery("");
    queryEl.current.value = "";
    queryEl.current.focus();
  };

  // update the query field to the full fund name when the fund
  // is selected
  useEffect(() => {
    diseaseFundRef.current = context.state.diseaseFund;
    if (diseaseFundRef.current) {
      queryEl.current.value = diseaseFundRef.current.name;
    }
  }, [context.state.diseaseFund]);

  // Clear the query input if an error is encountered. This aims
  // to prevent the user from thinking there is actually a fund
  // selected when there is not one set in the context's state.
  useEffect(() => {
    if (context.state.errorEncountered) {
      queryEl.current.value = "";
    }
  }, [context.state.errorEncountered]);

  const completeSearch = (event) => {
    event.preventDefault();
    setError("");

    if (!context.state.diseaseFund) {
      return setError("Please select a disease, medication, or service.");
    }

    // Open the modal and go to step 2
    context.actions.setModalOpen(true);
    context.actions.setStep(2);
  };

  return (
    <form onSubmit={(event) => completeSearch(event)} className="u-form">
      <div className="u-mb2">
        <label
          htmlFor={`eligibilityDiseaseSearch${
            props.inBillboard && "-billboard"
          }`}
        >
          Search for help
          {error && <span data-validate="error">{error}</span>}
        </label>
        <div className="u-relative">
          {context.state.diseaseFund && (
            <button
              className="QuickSearch-results-clear -clearSelection btn-reset"
              type="button"
              onClick={reset}
            >
              <div className="u-screenreader">Clear Form</div>
              <Icon name="close" width="16" height="16" />
            </button>
          )}
          <input
            ref={queryEl}
            type="text"
            id={`eligibilityDiseaseSearch${props.inBillboard && "-billboard"}`}
            autoComplete="off"
            defaultValue={(context.state.diseaseFund || {}).name}
            placeholder="Disease, medication, or service"
            onChange={(event) => handleSearch(event.target.value)}
          />
          {query &&
            !context.state.diseaseFund &&
            ((props.inBillboard && !context.state.modalOpen) ||
              !props.inBillboard) && (
              <SearchResults
                setError={setError}
                setQuery={setQuery}
                url={apiUrl}
                params={{ searchterm: query }}
                reset={reset}
              />
            )}
        </div>
      </div>

      <div className="u-mb3">
        <label htmlFor="eligibilityRole">I am a...</label>
        <select
          name="role"
          id="eligibilityRole"
          onChange={(event) => context.actions.setRole(event.target.value)}
          value={context.state.role}
        >
          <option value="patient">Patient</option>
          <option value="provider">Provider</option>
          <option value="pharmacy">Pharmacy</option>
        </select>
      </div>
      <button className="btn" type="submit">
        Next
      </button>
    </form>
  );
};

export default Search;
